import i18n from "@helpers/lib/i18n";
import { faqsEndpoint } from "./constants";
import type { Faq } from "./types";

export const getFaqs = async (
	projectName: string,
	language: string,
): Promise<Faq[]> => {
	try {
		const url = new URL(faqsEndpoint);
		url.searchParams.append("projectName", projectName);
		url.searchParams.append("language", language);

		const response = await fetch(url);

		if (!response.ok) {
			throw new Error(`Faqs fetch failed: ${response.status}`);
		}

		const data = (await response.json()) as Faq[];
		const sortedData = data?.sort((a, b) => a.order - b.order);

		return sortedData;
	} catch (_error) {
		return [];
	}
};

export const getFormattedLanguage = () => {
	const language = i18n.language;
	return language.split("-")[0];
};
